module.exports = __webpack_public_path__ + "static/media/add_black.9b64fa62.svg";